var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.857 376.739L450.127 430.879C455.23 432.079 460.341 428.915 461.54 423.812L467.691 397.65C468.891 392.547 465.727 387.436 460.623 386.236L215.825 328.68L116.148 370.627C111.316 372.66 109.047 378.226 111.081 383.059L121.504 407.829C123.539 412.662 129.104 414.931 133.936 412.897L219.857 376.739Z",
    fill: "url(#paint0_linear_201_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.764 267.579L474.009 329.23C479.105 330.465 484.237 327.336 485.472 322.241L491.805 296.123C493.041 291.028 489.912 285.896 484.817 284.66L215.919 219.457L76.8644 277.813C72.0299 279.842 69.7554 285.406 71.7843 290.24L82.1838 315.021C84.2126 319.855 89.7765 322.13 94.611 320.101L219.764 267.579Z",
    fill: "url(#paint1_linear_201_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.774 167.122L496.946 234.237C502.042 235.471 507.173 232.34 508.407 227.245L514.731 201.125C515.965 196.029 512.834 190.898 507.738 189.664L215.909 119L40.8173 192.593C35.9839 194.625 33.7125 200.19 35.7441 205.023L46.1572 229.798C48.1888 234.631 53.7539 236.903 58.5873 234.872L219.774 167.122Z",
    fill: "url(#paint2_linear_201_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_2",
    x1: 61.1072,
    y1: 349.876,
    x2: 324.07,
    y2: 491.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_2",
    x1: 76.7711,
    y1: 238.805,
    x2: 283.724,
    y2: 406.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_2",
    x1: 33.5768,
    y1: 140.551,
    x2: 277.078,
    y2: 300.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCard);
export default __webpack_public_path__ + "static/media/logo_card.0f0615983a37479f5e683dd767c2f420.svg";
export { ForwardRef as ReactComponent };